import { Component, OnInit } from '@angular/core';
import { DOWNLOAD_TYPE, IDownload, INavigation } from '@sv/interfaces';
import { CustomAppService } from 'src/app/_services/_content/customApp.service';
import { NavigationService } from 'src/app/_services/_content/navigation.service';

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss']
})
export class DownloadsComponent implements OnInit {
  navigation: INavigation;
  Math = Math;

  downloadSelected = false;
  selectedDownload: IDownload;

  DOWNLOAD_TYPE = DOWNLOAD_TYPE;

  loaded = false;

  constructor(private customAppService: CustomAppService, private navigationService: NavigationService) {}

  ngOnInit(): void {
    this.customAppService.getCustomAppListener().subscribe(async (app) => {
      if (typeof app.navigation === 'string') {
        this.navigation = await this.navigationService.getCompleteNavigationById(app.navigation);
      } else {
        this.navigation = app.navigation;
      }
      this.loaded = true;
    });
  }

  onDownload(download: IDownload) {
    if (screen.width > 699) {
      window.open(download.link, '_blank');
    } else {
      this.selectedDownload = download;
      this.downloadSelected = true;
    }
  }

  onMobileDowload() {
    window.open(this.selectedDownload.link, '_blank');
  }

  close() {
    this.selectedDownload = null;
    this.downloadSelected = false;
  }
}
